/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExternalUserSearchOrderBy } from './ExternalUserSearchOrderBy';
import {
    ExternalUserSearchOrderByFromJSON,
    ExternalUserSearchOrderByFromJSONTyped,
    ExternalUserSearchOrderByToJSON,
    ExternalUserSearchOrderByToJSONTyped,
} from './ExternalUserSearchOrderBy';
import type { SortOrder } from './SortOrder';
import {
    SortOrderFromJSON,
    SortOrderFromJSONTyped,
    SortOrderToJSON,
    SortOrderToJSONTyped,
} from './SortOrder';

/**
 * 
 * @export
 * @interface ExternalUserSearchOrderByPaginationQuery
 */
export interface ExternalUserSearchOrderByPaginationQuery {
    /**
     * 
     * @type {any}
     * @memberof ExternalUserSearchOrderByPaginationQuery
     */
    pageNumber?: any | null;
    /**
     * 
     * @type {any}
     * @memberof ExternalUserSearchOrderByPaginationQuery
     */
    pageSize?: any | null;
    /**
     * 
     * @type {SortOrder}
     * @memberof ExternalUserSearchOrderByPaginationQuery
     */
    sortOrder?: SortOrder;
    /**
     * 
     * @type {ExternalUserSearchOrderBy}
     * @memberof ExternalUserSearchOrderByPaginationQuery
     */
    orderField?: ExternalUserSearchOrderBy;
}



/**
 * Check if a given object implements the ExternalUserSearchOrderByPaginationQuery interface.
 */
export function instanceOfExternalUserSearchOrderByPaginationQuery(value: object): value is ExternalUserSearchOrderByPaginationQuery {
    return true;
}

export function ExternalUserSearchOrderByPaginationQueryFromJSON(json: any): ExternalUserSearchOrderByPaginationQuery {
    return ExternalUserSearchOrderByPaginationQueryFromJSONTyped(json, false);
}

export function ExternalUserSearchOrderByPaginationQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalUserSearchOrderByPaginationQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'pageNumber': json['pageNumber'] === undefined ? undefined : json['pageNumber'] === null ? null : json['pageNumber'],
        'pageSize': json['pageSize'] === undefined ? undefined : json['pageSize'] === null ? null : json['pageSize'],
        'sortOrder': json['sortOrder'] == null ? undefined : SortOrderFromJSON(json['sortOrder']),
        'orderField': json['orderField'] == null ? undefined : ExternalUserSearchOrderByFromJSON(json['orderField']),
    };
}

export function ExternalUserSearchOrderByPaginationQueryToJSON(json: any): ExternalUserSearchOrderByPaginationQuery {
    return ExternalUserSearchOrderByPaginationQueryToJSONTyped(json, false);
}

export function ExternalUserSearchOrderByPaginationQueryToJSONTyped(value?: ExternalUserSearchOrderByPaginationQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageNumber': value['pageNumber'],
        'pageSize': value['pageSize'],
        'sortOrder': SortOrderToJSON(value['sortOrder']),
        'orderField': ExternalUserSearchOrderByToJSON(value['orderField']),
    };
}

